import {computed, inject, ref, watch} from 'vue';

export default {
    install: (app, options) => {
        const appConfig = ref({
            // date_year: document.body.getAttribute('data-date-year'),
            // guest_main_url: document.body.getAttribute('data-app-main-url'),
            user_profile_logged_in: false,
            user_profile_logged_out: false,
            updated_user_wallet_updated: false,
        });

        const hex2rgb = (hex) => {
            const r = parseInt(hex.slice(1, 3), 16);
            const g = parseInt(hex.slice(3, 5), 16);
            const b = parseInt(hex.slice(5, 7), 16);

            return {r, g, b};
        };

        const dataAppParameters = JSON.parse(document.body.getAttribute('data-app-parameters'));

        const getCompanyColorRgb = (opacity = 100) => {
            const rgb = appParameters.value.company_colour_rgb;

            return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${opacity / 100})`;
        };

        const appParameters = ref({
            getCompanyColorRgb: getCompanyColorRgb,
            company_id: dataAppParameters.company_id,
            company_name: dataAppParameters.company_name,
            company_logo: dataAppParameters.company_logo,
            company_colour: dataAppParameters.company_colour,
            company_colour_rgb: hex2rgb(dataAppParameters.company_colour),
            company_symbol: dataAppParameters.company_symbol,
        });

        watch(() => appParameters.value.company_colour, (value) => {
            appParameters.value.company_colour_rgb = hex2rgb(value);
        });

        app.provide('appProvider', {
            appConfig,
            appParameters,
        });
    },
}
